import { render, staticRenderFns } from "./ColorServices.vue?vue&type=template&id=68a5b770"
import script from "./ColorServices.vue?vue&type=script&lang=js"
export * from "./ColorServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports